import { Box, CircularProgress } from "@mui/material"

function JLoading() {
  return (
    <Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
      <CircularProgress color="primary" />
    </Box>
  )
}

export default JLoading